export default __webpack_public_path__ + "static/media/homepage-header-image.55eaf673.png";